const Staff = () => {
  return (
    <div>
      <h1>Staff</h1>
      {/* Staff content goes here */}
    </div>
  );
};

export default Staff;
